<div class="width-100 p-1 overflow-x-hidden" style="height: 500px;">
  <div class="row">
    <div class="col-md-11">
      <autocomplete-variacoes
        id="field-variacao"
        [autoFirst]="false"
        placeholder="Selecionar itens de uma variação"
        class="width-100"
        displayField="descricao"
        displaySecondField="variacao.descricao"
        [value_order]="'descricao'"
        [displayWithEntityFn]="varicaoDisplay"
        [controlIsEnabled]="variacaoControl.enabled"
        [pageValue]="'0'"
        [pageSizeValue]="'10'"
        [include]="['variacao']"
        [control]="variacaoControl"
        [domain_id]="tokenService.getDomain().id"
        [entityService]="variacaoItensService"
        [actionState]="true"
        [initDataWithEmpty]="true"
        [insertType]="'variacao_produto'"
        (selectEntity)="adicionarVariacoes($event, true)"
        (clearSelection)="variacaoControl.reset()"
        [messages]="{
          typeIs: 'Valor inválido',
          isEmptyValue: 'Valor inválido: remova os espaços em branco!'
        }"
      ></autocomplete-variacoes>
      <mat-hint class="mt-2">
        Exemplo: Cor+Azul
      </mat-hint>
    </div>
    <button
      pButton
      pRipple
      type="button"
      id="btn-reload-entities"
      icon="pi pi-filter"
      (click)="openFilterVariacoes()"
      matTooltip="Pesquisar variações"
      class="p-button-rounded p-button-primary p-button-outlined mt-3"
    ></button>
  </div>
  <div
    class="flex align-items-center justify-content-end"
    *ngIf="variacoes.value.length"
  >
    <button
      pButton
      pRipple
      type="button"
      icon="pi pi-check-circle"
      (click)="criarProdutosVariacao()"
      label="Gerar combinação do produto"
      class="p-button-rounded p-button-success p-button-outlined p-button-sm"
    ></button>
  </div>
  <mat-tab-group>
    <mat-tab label="Variações selecionadas">
      <app-table-produto-variacoes
        [showVariacoes]="true"
        [variacoes]="variacoes.value"
        (onRemoveVariacao)="removerVariacao($event)"
        (onRemoveVariacaoItem)="removerItemVariacao($event)"
        (onRemoveAllVariacaoItem)="removerAllItemVariacao($event)"
        (onRemoveAllVariacao)="removerAllVariacao()"
      >
      </app-table-produto-variacoes>
    </mat-tab>
    <mat-tab
      label="Produtos variação"
      *ngIf="produtos_variacao.value.length"
      [disabled]="changedVariacao"
    >
      <app-table-produto-variacoes
        [showProdutos]="true"
        [updateRowsVariacao]="updateRowsVariacao"
        [produto_existe]="entity.id ? true : false"
        [valor_minimo]="valor_minimo"
        [quantidade]="quantidade"
        [produtos]="produtos_variacao.value"
        (onRemoveProdutoVariacao)="removerProdutoVariacao($event)"
        (onRemoveAllProdutosVariacao)="removerAllProdutoVariacao()"
        (onUpdateProduto)="entity.id ? updateVariacoesProduto() : null"
      >
      </app-table-produto-variacoes>
    </mat-tab>
  </mat-tab-group>
</div>
